import type { TaskStatus } from '../../../api/types';

// PARA-135 (B-1) — ЕДИНСТВЕННОЕ место, кодирующее решения РЕШ-2 и РЕШ-3.
// Решение принимается ТОЛЬКО по статусу нажатой задачи: списка задач функция
// не принимает и «текущую задачу в работе» не ищет — лимита на IN_PROGRESS
// нет ни на клиенте, ни на сервере (РЕШ-8, AC-5b).

/** Целевой статус для короткого тапа по телу карточки; null = no-op. */
export function nextStatusForTap(status: TaskStatus): TaskStatus | null {
  switch (status) {
    // AC-1, AC-2 — «взять в работу»: все три перехода разрешены машиной
    // состояний backend (_ALLOWED_TRANSITIONS, PARA-104).
    case 'BACKLOG':
    case 'PLANNED':
    case 'PAUSED':
      return 'IN_PROGRESS';
    // AC-4 — единственный неразрушающий переход из IN_PROGRESS (РЕШ-2).
    case 'IN_PROGRESS':
      return 'PAUSED';
    // AC-5 — DONE/CANCELLED: запрос не отправляется вовсе (РЕШ-3).
    case 'DONE':
    case 'CANCELLED':
      return null;
  }
}
